import { Close, KeyboardArrowDown } from '@mui/icons-material';
import type { Components, CssVarsTheme } from '@mui/material/styles';
import { createElement } from 'react';

export const MuiAutocomplete: Components<CssVarsTheme>['MuiAutocomplete'] = {
  defaultProps: {
    noOptionsText: 'Không có dữ liệu',
    disableClearable: false,
    slotProps: {
      chip: {
        size: 'small',
        variant: 'soft'
      }
    },
    popupIcon: createElement(KeyboardArrowDown, { className: 'size-4' }),
    clearIcon: createElement(Close, { className: 'size-4' })
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& span.MuiAutocomplete-tag': {
        fontWeight: 600,
        lineHeight: '24px',
        fontSize: '0.85rem',
        height: 24,
        minWidth: 24,
        textAlign: 'center',
        padding: '0px 6px',
        color: theme.vars.palette.text.secondary,
        borderRadius: 8,
        backgroundColor: theme.vars.palette.action.selected
      }
    }),
    paper: ({ theme }) => ({
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      backgroundColor: theme.vars.palette.background.paper,
      backgroundImage: 'none',
      backgroundRepeat: 'no-repeat, no-repeat',
      backgroundPosition: 'top right, left bottom',
      backgroundSize: '50%, 50%',
      padding: '4px',
      boxShadow: theme.vars.customShadows.dropdown,
      borderRadius: 10
    }),
    listbox: ({ theme }) => ({
      padding: 0,
      '&::-webkit-scrollbar': {
        width: 4
      },
      '& .MuiAutocomplete-option': {
        lineHeight: 1.5714285714285714,
        fontSize: '0.875rem',
        fontFamily: 'Public Sans, sans-serif',
        fontWeight: 400,
        padding: '6px 8px',
        borderRadius: 6,
        '&:not(:last-of-type)': {
          marginBottom: 4
        },
        '&.Mui-selected': {
          fontWeight: 600,
          backgroundColor: theme.vars.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.vars.palette.action.hover
          }
        },
        '& .MuiCheckbox-root': {
          padding: '4px',
          marginLeft: '-4px',
          marginRight: '4px'
        },
        '&.MuiAutocomplete-option[aria-selected="true"]': {
          backgroundColor: theme.vars.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.vars.palette.action.hover
          }
        },
        '&+.MuiDivider-root': {
          margin: '4px 0px'
        }
      }
    }),
    endAdornment: {
      '& .MuiSvgIcon-root': {
        width: 18,
        height: 18
      }
    }
  }
};
